<template>
  <button
    class="relative mx-2 flex h-12 w-12 items-center justify-center"
    :title="title"
    @click="$emit('click')"
  >
    <figure
      class="relative h-10 w-10 overflow-hidden rounded-full shadow after:absolute after:inset-0 after:bg-black after:transition-all after:duration-300 after:content-['']"
      :class="[
        darkerBg ? 'after:opacity-60' : 'after:opacity-25',
        isActive && 'after:!opacity-0',
      ]"
    >
      <img
        :src="imgUrl"
        :alt="title"
        loading="lazy"
        class="pointer-events-none absolute left-0 top-0 h-full w-full object-cover"
      />
    </figure>
    <div v-if="isActive" class="element-progress absolute left-0 top-0 z-10">
      <svg
        viewBox="0 0 44 44"
        class="h-full w-full"
        :style="`stroke-dashoffset: ${strokeDashoffset}`"
      >
        <circle cx="22" cy="22" r="20" />
      </svg>
    </div>
  </button>
</template>

<script setup lang="ts">
  interface IProps {
    imgUrl: string;
    swiperProgress: number;
    isActive: boolean;
    title?: string;
    darkerBg?: boolean;
  }

  const props = withDefaults(defineProps<IProps>(), {
    title: '',
    darkerBg: false,
  });

  defineEmits<{ (e: 'click'): void }>();

  const strokeDashoffset = computed((): number => {
    return 125.6 * (1 - props.swiperProgress);
  });
</script>

<style lang="scss" scoped>
  .element-progress svg {
    stroke-width: 2px;
    stroke: #006eff;
    fill: none;
    stroke-dasharray: 125.6;
    transform: rotate(-90deg);
  }
</style>
